// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-app-page-hook-js": () => import("./../../../src/app/page-hook.js" /* webpackChunkName: "component---src-app-page-hook-js" */),
  "component---src-app-page-js": () => import("./../../../src/app/page.js" /* webpackChunkName: "component---src-app-page-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

